import { DataExportAction, useDataExport } from "contexts/DataExportContext";
import { ToastDetails, ToastState } from "models/ToastDetails";
import React, { useCallback, useEffect } from "react";

import { createOrUpdateToast } from "./AppToast";

const DEFAULT_TOAST_DURATION_MILLISECONDS = 60_000;

export const DataExportToastManager: React.FC = () => {
  const { state, dispatch } = useDataExport();

  const handleDismiss = useCallback((): void => {
    dispatch(DataExportAction.DismissToastAndIncrementToastId);
  }, [dispatch]);

  useEffect(() => {
    if (!state.toastVisible) {
      return;
    }

    const toastId = state.toastId.toString();

    let toastDetails: ToastDetails;

    if (state.count) {
      toastDetails = {
        id: toastId,
        title: `Exporting, ${state.count} remaining...`,
        message: "We are preparing your data for export",
        state: ToastState.InProgress,
      };
    } else if (state.errorCount) {
      toastDetails = {
        id: toastId,
        title: `${state.errorCount} export${
          state.errorCount > 1 ? "s" : ""
        } failed`,
        message: "Please try again later.",
        state: ToastState.Error,
      };
    } else {
      toastDetails = {
        id: toastId,
        title: "Export complete",
        state: ToastState.Complete,
      };
    }

    createOrUpdateToast(
      toastDetails,
      DEFAULT_TOAST_DURATION_MILLISECONDS,
      handleDismiss,
      "export-toast-container"
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps -- updating on toastId causes an unnecessary render and it isn't changed elsewhere
  }, [state.count, state.errorCount, state.toastVisible]);

  return <></>;
};
